import {Position} from './../interfaces/positions';

export const POSITIONS_LIST: Position[] = [{id: 1, name: 'First'}, {id: 2, name: 'Last'}];
